export enum QuestionTypesEnum {
    SINGLE = 0,
    MULTIPLE = 1,
    FORM = 2,
    MATRIX = 3,
    FREE = 4,
    SECTION = 5,
}
